import { Injectable } from '@angular/core';

import { UserUsageStatsOutput } from 'infrastructure/graphql/messaging/user/model/user-usage-stats.output';
import { UserStatisticsOutput } from 'user/model/user-statistics.output';
import { UserUsageStats } from 'user/user-usage-stats';

@Injectable({ providedIn: 'root' })
export class UserUsageStatsConverterService {
	public userUsageStatAsEntity(
		usageOutput: UserUsageStatsOutput,
		statisticsOutput: UserStatisticsOutput
	): UserUsageStats {
		return usageOutput || statisticsOutput
			? new UserUsageStats(
					statisticsOutput?.doneTasks,
					statisticsOutput?.pendingTasks,
					statisticsOutput?.doneJobMeetings,
					statisticsOutput?.pendingJobMeetings,
					statisticsOutput?.doneContactMeetings,
					statisticsOutput?.pendingContactMeetings,
					usageOutput?.messagesSent,
					usageOutput?.messagesSentMax,
					usageOutput?.messagesSentPeriod
			  )
			: null;
	}
}
